
import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    isModeAssociatedNovels: Boolean,
  },
  computed: {
    title() {
      return this.isModeAssociatedNovels
        ? this.$t('nolaNovelEmptyList.posted.title')
        : this.$t('nolaNovelEmptyList.nonPosted.title');
    },
    message() {
      return this.isModeAssociatedNovels
        ? this.$t('nolaNovelEmptyList.posted.message')
        : this.$t('nolaNovelEmptyList.nonPosted.message');
    },
    actionName() {
      return this.isModeAssociatedNovels
        ? this.$t('nolaNovelEmptyList.posted.actionButton')
        : this.$t('nolaNovelEmptyList.nonPosted.actionButton');
    },
  },
  methods: {
    onClickButton() {
      const { isModeAssociatedNovels } = this;
      if (isModeAssociatedNovels) this.$emit("clickNonAssociatedNovels");
      else this.$router.push({ name: "novelCreate" });
    },
  },
});

interface Props {
  isModeAssociatedNovels: boolean;
}

interface Data {}

interface Computed {
  title: string;
  message: string;
  actionName: string;
}

interface Methods {
  onClickButton(): void;
}
